/**
 * BulkActions — Group de botoes visiveis no slot `extra` do DataCard
 * quando ha rows selecionadas.
 *
 * Spec §3.2: mark-read | dismiss | clear selection.
 * Audit gravado backend-side via PATCH endpoints (notifications:mark_read, etc).
 */
import { Group, Button, Badge } from '@mantine/core'
import { IconCheck, IconEyeOff, IconX } from '@tabler/icons-react'
import { notifications } from '@mantine/notifications'
import { notificationsFeedApi } from '@/api/notifications-feed'

interface Props {
  selected: Set<number>
  onClear: () => void
  onDone: () => void
}

export function BulkActions({ selected, onClear, onDone }: Props) {
  const ids = Array.from(selected)

  const handleMarkRead = async () => {
    try {
      const res = await notificationsFeedApi.markRead(ids)
      notifications.show({ color: 'green', title: 'Marcadas como lidas', message: `${res.marked_count} notificações.` })
      onDone()
    } catch (e) {
      notifications.show({ color: 'red', title: 'Erro', message: String((e as Error)?.message ?? e) })
    }
  }

  const handleDismiss = async () => {
    try {
      const res = await notificationsFeedApi.dismiss(ids)
      notifications.show({ color: 'green', title: 'Descartadas', message: `${res.dismissed_count} notificações.` })
      onDone()
    } catch (e) {
      notifications.show({ color: 'red', title: 'Erro', message: String((e as Error)?.message ?? e) })
    }
  }

  return (
    <Group gap="xs">
      <Badge size="sm" variant="light" color="blue">{ids.length} selecionada(s)</Badge>
      <Button size="xs" leftSection={<IconCheck size={14} />} onClick={handleMarkRead}>
        Marcar lidas
      </Button>
      <Button
        size="xs"
        variant="subtle"
        color="orange"
        leftSection={<IconEyeOff size={14} />}
        onClick={handleDismiss}
      >
        Descartar
      </Button>
      <Button size="xs" variant="subtle" leftSection={<IconX size={14} />} onClick={onClear}>
        Limpar
      </Button>
    </Group>
  )
}
